module.exports = __webpack_public_path__ + "img/allow-down.9d774fc3.svg";